import { GTM_EVENT } from '@/shared/constants/gtm';
import { pushGTMEvent, toBtnName } from '@/shared/utils/gtm';

/**
 * 쿠폰 이벤트(시트 row 33 `click_coupon` / row 34 `issue_coupon`)의 전자상거래 속성.
 *
 * 쿠폰은 현재 라운지멤버십 전용으로만 개발돼 있어 사업부(item_category)와
 * 상품 구분(item_category2)이 고정이다. 다른 상품에 쿠폰이 열리면 인자로 받아야 한다.
 */
export const COUPON_ITEM_CATEGORY = '라운지멤버십';

/** GA `item_name` — 화면 표기와 같은 "상품명-요금제명". 요금제 미선택 시 상품명만. */
export function couponItemName(productName?: string, policyName?: string) {
  return [productName, policyName].filter(Boolean).join('-');
}

/**
 * dataLayer 로 직접 push 할 때.
 *
 * `itemName` 은 상품이 특정되는 화면에서만 넘긴다 — 마이페이지 쿠폰함처럼
 * 계정 단위로 발급되는 화면은 상품을 특정할 수 없어 키를 아예 싣지 않는다.
 */
export function couponItemParams(itemName?: string) {
  return {
    item_category: COUPON_ITEM_CATEGORY,
    item_category2: COUPON_ITEM_CATEGORY,
    ...(itemName && { item_name: toBtnName(itemName) }),
  };
}

/** data 어트리뷰트로 마크업에 남길 때 — 전역 리스너가 dataLayer 로 옮긴다. */
export function couponItemAttributes(itemName?: string) {
  return {
    'data-item-category': COUPON_ITEM_CATEGORY,
    'data-item-category2': COUPON_ITEM_CATEGORY,
    ...(itemName && { 'data-item-name': toBtnName(itemName) }),
  };
}

/**
 * row 34 `issue_coupon` — 클릭이 아니라 실제 발급 성공 시점에 집계한다.
 * (비로그인이면 발급 없이 로그인 화면으로 빠지므로 클릭 시점은 과대 집계)
 *
 * 시트 비고대로 여러 장을 한 번에 받으면 쿠폰명 대신 `coupon=전체받기` 로 묶는다.
 */
export function pushIssueCoupon({
  btnName,
  couponIds,
  resolveCouponName,
  itemName,
}: {
  btnName: string;
  couponIds: number[];
  /** 발급된 id 로 쿠폰명을 찾는다 — 단일 발급일 때만 쓰인다. */
  resolveCouponName?: (couponId: number) => string | undefined;
  itemName?: string;
}) {
  pushGTMEvent(GTM_EVENT.ISSUE_COUPON, {
    btnname: toBtnName(btnName),
    coupon:
      couponIds.length > 1
        ? '전체받기'
        : toBtnName(resolveCouponName?.(couponIds[0]) ?? ''),
    ...couponItemParams(itemName),
  });
}
